module.exports = __webpack_public_path__ + "static/media/decentralized.7311f095.svg";